module.exports = __webpack_public_path__ + "static/media/0.c0bc02a0.jpg";